angular
    .module('MW.ContactManager.AutoDownloader', [])
    .directive('autoDownloader', [function() {
        'use strict';

        return {
            restrict: 'E',
            scope: {},
            link: function(scope, element, attrs) {
                var mimeType = 'text/csv';

                scope.fileName = 'failed_contacts.csv';

                attrs.$observe('toDownload', function(toDownload) {
                    if(toDownload && toDownload.length > 0) {
                        var blob = new Blob([toDownload], {type: mimeType}),
                            objectUrl = window.URL.createObjectURL(blob);

                        element.find('.downloadLink').attr('href', objectUrl);
                        element.find('.downloadLink')[0].click();
                    }
                });
            },
            templateUrl: 'icm-web/views/partials/auto_downloader'
        };
    }]);